{
  "competitionId": "comp-global-01",
  "name": "Liga Global de Mánagers",
  "divisions": [
    {
      "divisionNumber": 1,
      "name": "Primera División",
      "groups": [
        {
          "groupId": "league-global-01",
          "name": "Grupo 1",
          "teamsCount": 20
        }
      ]
    }
  ],
  "totalCycles": 38,
  "currentCycle": 5
}
